import { GET_WORKER_APPOINTMENTS } from "../../../../enums/AuthType";

export const workAppontmentsAction = (data) => {
    return {
        type: GET_WORKER_APPOINTMENTS,
        payload: data,
    };
};
